import { ModSortBy, ModSortByType } from '../../../constants/enums';
import { Mod } from '../types/modTypes';

/**
 * Extracts a numeric epoch timestamp from a Mod for sorting purposes.
 * Supports both `createdAt`/`updatedAt` and legacy alias `createDate`/`updateDate`.
 */
export const getModTimestamp = (mod: Mod, sortBy: ModSortByType = ModSortBy.UPDATED_AT): number => {
  const dateStr =
    sortBy === ModSortBy.CREATED_AT
      ? mod.createdAt || mod.createDate || mod.updatedAt || mod.updateDate
      : mod.updatedAt || mod.updateDate || mod.createdAt || mod.createDate;

  if (!dateStr) {
    return 0;
  }

  const timestamp = new Date(dateStr).getTime();
  return Number.isNaN(timestamp) ? 0 : timestamp;
};

/**
 * Sorts an array of mods by either update date (`ModSortBy.UPDATED_AT`) or
 * create date (`ModSortBy.CREATED_AT`), newest first.
 */
export const sortMods = (mods: Mod[], sortBy: ModSortByType = ModSortBy.UPDATED_AT): Mod[] => {
  return [...mods].sort((a, b) => getModTimestamp(b, sortBy) - getModTimestamp(a, sortBy));
};
